import firebase from 'firebase'
import { firebaseAction } from 'vuexfire'

const state = {
  all: []
}

const getters = {
  all: state => state.all,
  find: state => id => state.all.find((store) => store.id === id)
}

const actions = {
  bind: firebaseAction(({ bindFirebaseRef }, company) => {
    if (company && company.id) {
      console.log('fetching')
      bindFirebaseRef('all', firebase.firestore().collection('companies').doc(company.id).collection('stores'))
    }
  }),
  add ({ rootGetters }, store) {
    const company = rootGetters['companies/mine']
    if (company && company.id) {
      return firebase.firestore().collection('companies').doc(company.id).collection('stores').add(store)
    }
  }
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/stores.js